/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ShareLinkIcon = createIcon("ShareLinkIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "80",
    cy: "80",
    r: "80",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 94.013 28-28M68.627 80.072a11.925 11.925 0 00-9.112 3.467l-6 6a12 12 0 1016.97 16.97l6-6a11.92 11.92 0 003.467-9.112m11.421-11.445a11.93 11.93 0 009.112-3.467l6-6a11.998 11.998 0 000-16.97 11.998 11.998 0 00-16.97 0l-6 6a11.934 11.934 0 00-3.454 9.112",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});